
class SearchResultsAPILayer {
  constructor() {

    this.eventBus = window.theme.searchResults.eventBus;

    this.waitForNostoJS().then(() => {
      this.fetchResults();
    });

    this.eventBus.subscribe('searchResults:api:fetch:products', () => {
      this.fetchResults();
    });

    this.eventBus.subscribe('searchResults:tracking:product:clicked', (productData) => {
      nostojs(api => {
        api.recordSearchClick('serp',{
          productId: productData.productId,
          url: productData.url,
        });
      });
    });

    this.eventBus.subscribe('searchResults:tracking:product:added', (productData) => {
      const completeUrl = location.origin + productData.url
      nostojs(api => {
        api.recordSearchAddToCart('serp', {
          productId: productData.productId,
          url: completeUrl,
        })
      })
    })
  }

  async waitForNostoJS() {
    return new Promise((resolve) => {
      const checkInterval = setInterval(() => {
        if (window.nostojs) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 50);
    });
  }

  async fetchResults() {
    const searchParams = new URLSearchParams(window.location.search);
    const term = searchParams.get('q') || '';

    nostojs(api => {
      api.search({
        query: term || '',
        products: {
          fields: ['name', 'imageUrl', 'alternateImageUrls', 'price', 'listPrice', 'url', 'skus.name', 'skus.id', 'skus.inventoryLevel'],
          size: window.theme.categoryConfig.productsPerPage,
          facets: ['*'],
          filter:  window.theme.searchResults.stateLayer?.state?.activeFacets || [],
          sort:  window.theme.searchResults.stateLayer?.state?.activeSort || [],
          from:  window.theme.searchResults.stateLayer?.state?.pagination?.from || 0
        },
        keywords: {
          fields: ['keyword'],
          size: 5
        }
      }, {
        redirect: true,
        track: 'serp',
      }).then(response => {
        const facets = response.products.facets;
        if (facets) {
          this.eventBus.publish('searchResults:api:facets:fetched', facets);
        }

        this.eventBus.publish('searchResults:api:results:fetched', response);
      });
    });
  }
}

window.theme.searchResults.apilayer = new SearchResultsAPILayer();
